import React from 'react';
import { cn } from '@/lib/utils';

interface MindfullLogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  showText?: boolean;
  className?: string;
}

const sizeClasses = {
  sm: 'w-7 h-7',
  md: 'w-8 h-8',
  lg: 'w-10 h-10',
  xl: 'w-14 h-14',
};

const textSizeClasses = {
  sm: 'text-lg',
  md: 'text-xl',
  lg: 'text-2xl',
  xl: 'text-3xl',
};

const letterSizeClasses = {
  sm: 'text-lg',
  md: 'text-xl',
  lg: 'text-2xl',
  xl: 'text-3xl',
};

export const MindfullLogo: React.FC<MindfullLogoProps> = ({ 
  size = 'md', 
  showText = true,
  className 
}) => {
  return (
    <div className={cn("flex items-center gap-2.5", className)}>
      <div 
        className={cn(
          sizeClasses[size],
          "bg-white rounded-lg flex items-center justify-center shadow-sm border border-border/30"
        )}
      >
        <span className={cn(
          letterSizeClasses[size],
          "font-bold text-foreground leading-none"
        )}>
          M
        </span>
      </div>
      {showText && (
        <span className={cn(
          textSizeClasses[size],
          "font-semibold tracking-tight text-foreground"
        )}>
          Mindfull
        </span>
      )}
    </div>
  );
};

export default MindfullLogo;
